import { SupportedDestinations, SUPPORTED_DESTINATION_IDS } from 'home/constants'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'

const SUPPORTED_DESTINATION_SLUGS = new Set<string>(Object.values(SupportedDestinations))

export function getSupportedDestinationFromPathname(pathname: string): SupportedDestinations | undefined {
  const match = matchLocaleAwarePath<{ destination?: string }>(pathname, {
    path: '/:regionCode/destination/:destination',
    exact: false,
  })
  const slug = match?.params.destination?.toLowerCase()

  if (slug && SUPPORTED_DESTINATION_SLUGS.has(slug)) {
    return slug as SupportedDestinations
  }

  return undefined
}

export function getSupportedDestinationIdFromPathname(pathname: string): string | undefined {
  const destination = getSupportedDestinationFromPathname(pathname)
  return destination ? SUPPORTED_DESTINATION_IDS[destination] : undefined
}
